/**
 * Service `EnergyContract` — **lecture** des contrats énergétiques côté `core/`.
 *
 * Tape la façade api-metier `GET /api/metier/v5/energycontracts` via l'axios
 * `core` (interceptor JWT + x-tracking-id). Volontairement autonome (aucun
 * import de `@modules/courtage`) : un composant `core/` qui importait le service
 * courtage faisait crasher la card à l'init en prod parce que le chunk lazy
 * `courtage` n'était pas résolu (DEV-594 — rollback front v346→v347).
 *
 * L'édition/écriture reste côté courtage (`DialogEnergyContractGazEdit`,
 * auto-importé et chargé seulement à l'ouverture du modal).
 */

import axios from "@core/plugins/axios.plugin"
import { handleServiceCall } from "@services/helpers"
import type {
    EnergyContract,
    EnergyContractListResponse,
    TypeEnergie,
} from "@core/types/energy-contract"

export class EnergyContractService {
    /**
     * Liste les contrats d'une company, optionnellement filtrés par énergie.
     *
     * @param companyId - `_id_company` (envoyé en query ; la façade re-scope
     *   côté serveur sur la company de l'utilisateur authentifié).
     * @param typeEnergie - filtre `type_energie` optionnel (`gaz`, `elec`, ...).
     * @param controller - annulation de requête.
     */
    async listEnergyContracts(
        companyId: string,
        typeEnergie?: TypeEnergie,
        controller?: AbortController
    ): Promise<EnergyContract[]> {
        return handleServiceCall<EnergyContract[]>(async () => {
            const params: Record<string, string> = { _id_company: companyId }
            if (typeEnergie) params.type_energie = typeEnergie
            const { data } = await axios.get<EnergyContractListResponse>(
                "/api/metier/v5/energycontracts",
                { params, signal: controller?.signal }
            )
            return data.data
        })
    }
}
